import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class MercenaryShipSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.MERCENARY_SHIP;
}

export default MercenaryShipSalvageableTileEntity;
